import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CloseSvg from "../../../assets/svgs/CloseSvg";
import classNames from "classnames";
import { Search_Icon } from "../../../assets/images";
import ArrowUpRight from "../../../assets/svgs/ArrowUpRight";
import moment from "moment";
import {
  useCreateOneAppointmentMutation,
  useFetchAllPatientsMutation,
  useFetchVisitTypesMutation
} from "../../../features/appointment/appointmentApiSlice";
import {
  useGetLocationsMutation,
  useSuggestLocationsMutation,
  useAttachLocationMutation,
} from "../../../features/patient/patientApiSlice";
import ReusableModal from "../../../components/Modals/ReusableModal";
import { useMapStore } from "../../../context/map.store";
import DownArrow from "@mui/icons-material/KeyboardArrowDownRounded";
import { Grid, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { latlong } from "../../../data";
import Loading from "../../../components/Loading";
import { Icon } from "@virtuslab/tetrisly-icons";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
  ADDRESS_GEN_TYPE,
} from "../../../constants/config.constants";
import { useCreateLogsMutation } from "../../../features/logs/logsApiSlice";
import { selectUser } from "../../../features/auth/authSlice";
import { useSelector } from "react-redux";
import useDebounce from "../../../hooks/useDebounce";
import InfoModal from "../../../components/Modals/InfoModal";
import LatLongDisplay from "../../CareManagement/Patient/components/LatLatLongDisplay";

const AppointmentAddModal = ({
  selectedProvider,
  addOpen,
  setAddOpen,
  weeks,
  onAdd,
  filterOptions,
  setRecallSchedule,
  appointmentsCount,
  selectedDate,
  fetchFilterOptions,
  created_from,
}) => {
  const routerLocation = useLocation();
  const { setPatientSelected } = useMapStore((state) => state);
  const [visitDate, setVisitDate] = useState(
    moment(selectedDate).format("YYYY-MM-DD"),
  );
  const [visitDateOpen, setVisitDateOpen] = useState(false);

  const user = useSelector(selectUser);

  const [visitType, setVisitType] = useState("NORMAL");

  const [searchType, setSearchType] = useState("ALL");
  const [location, setLocation] = useState(null);
  const [locationOpen, setLocationsOpen] = useState(false);

  const [patient, setPatient] = useState(null);
  const [patientsOpen, setPatientsOpen] = useState(false);

  const [city, setCity] = useState(null);
  const [cityOpen, setCityOpen] = useState(false);

  const [zip, setZip] = useState(null);
  const [zipOpen, setZipOpen] = useState(false);

  const [zone, setZone] = useState(null);
  const [zoneOpen, setZoneOpen] = useState(false);

  const [zoneSearch, setZoneSearch] = useState("");

  const [appointmentType, setAppointmentType] = useState(null);
  const [appointmentTypesOpen, setAppointmentTypesOpen] = useState(false);
  const [changeAddressModalOpen, setChangeAddressModalOpen] = useState(false);

  const [patientSearch, setPatientSearch] = useState("");
  const [address, setAddress] = useState("");
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedVisitLocation, setSelectedVisitLocation] = useState(null);
  const [saveAddressToProfile, setSaveAddressToProfile] = useState(false);
  const [manualAddress, setManualAddress] = useState(null);
  const [useManualEntry, setUseManualEntry] = useState(false);
  const [citySearch, setCitySearch] = useState("");
  const [zipSearch, setZipSearch] = useState("");
  const [communitySearch, setCommunitySearch] = useState("");
  const [appointmentTypeSearch, setAppointmentTypeSearch] = useState("");
  const [message, setMessage] = React.useState([]);
  const [error, setError] = React.useState(null);

  const [patientType, setPatientType] = useState("All");
  const [patientAnchor, setPatientAnchor] = useState(null);

  const [patients, setPatients] = useState([]);
  const [locations, setLocations] = useState([]);
  const [appointmentTypes, setAppointmentTypes] = useState([]);
  const search = useDebounce(patientSearch, 750);
  const addressSearch = useDebounce(address, 750);
  const [createOneAppointment, { isLoading }] =
    useCreateOneAppointmentMutation();

  const [fetchAllPatients, { isLoading: patientsLoading }] =
    useFetchAllPatientsMutation();

  const [getLocations, { isLoading: locationsLoading }] =
    useGetLocationsMutation();

  const [suggestLocations, { isLoading: suggestLocationsLoading }] =
    useSuggestLocationsMutation();

  const [attachLocation, { isLoading: attachLocationLoading }] =
    useAttachLocationMutation();
  const [fetchVisitTypes] = useFetchVisitTypesMutation();

  const [createLog] = useCreateLogsMutation();

  const loading =
    isLoading || patientsLoading || locationsLoading || attachLocationLoading;

  const getAllPatients = async () => {
    if (patientType === "Cross Cover") {
      const { data } = await fetchAllPatients({
        take: "40",
        skip: "0",
        search: search,
        date: visitDate,
        providerId: selectedProvider.id,
        communityId: searchType === "COMMUNITY" ? location?.id : null,
        city: searchType === "CITY" ? city : null,
        zip: searchType === "ZIP" ? zip : null,
      });
      setPatients(data.data);
    }
  };

  const fetchVisitTypesData = async () => {
    const { data } = await fetchVisitTypes({
      // search: appointmentTypeSearch,
      take: 50,
      patientId: patient.id,
    });
    setAppointmentTypes(data.data);
  };

  const attachLocationData = async () => {
    // Use manual address if available, otherwise use selected address
    try {
      const addressData =
        useManualEntry && manualAddress
          ? {
              locationId: null,
              street: manualAddress.street,
              city: manualAddress.city,
              state: manualAddress.state,
              county: null,
              zip: manualAddress.zip,
              latitude: null,
              longitude: null,
            }
          : {
              locationId: selectedAddress.placeId,
              street: selectedAddress.street,
              city: selectedAddress.city,
              state: selectedAddress.state,
              county: selectedAddress.county,
              zip: selectedAddress.zip,
              latitude: selectedAddress.lat,
              longitude: selectedAddress.lng,
            };

      const result = await attachLocation({
        patientId: patient.id,
        ...addressData,
        saveAddressToProfile: saveAddressToProfile,
        manualAddress: useManualEntry ? manualAddress : null,
      }).unwrap();

      const newLocation = {
        id: addressData.locationId || result?.data?.id,
        street: addressData.street,
        city: addressData.city,
        state: addressData.state,
        zip: addressData.zip,
        latitude: result?.data?.latitude || addressData.latitude,
        longitude: result?.data?.longitude || addressData.longitude,
        county: addressData.county,
        addressType: "SECONDARY",
        coord_generation_type:
          address?.coord_generation_type || ADDRESS_GEN_TYPE.AUTO,
      };

      setLocations([...locations, newLocation]);
      setSelectedVisitLocation(newLocation);
      setSelectedAddress(null);
      setAddress("");
      setSaveAddressToProfile(false);
      setUseManualEntry(false);
      setManualAddress(null);
      setChangeAddressModalOpen(false);
      setMessage([]);
    } catch (error) {
      console.log(error);
      setMessage([error?.data?.message]);
    }
  };

  useEffect(() => {
    getAllPatients();
  }, [patientType, visitDate, search, location, city, zip]);

  useEffect(() => {
    if (patient) {
      fetchVisitTypesData();
    }
  }, [patient]);

  const setDefaultValues = () => {
    setVisitDate("");
    setVisitType("NORMAL");
    setSearchType("ALL");
    setLocation(null);
    setPatient(null);
    setAppointmentType(null);
    setVisitDateOpen(false);
    setLocationsOpen(false);
    setPatientsOpen(false);
    setAppointmentTypesOpen(false);
    setPatientSelected(null);
  };

  const showAlert = (msg) => {
    setMessage(msg);
  };

  const getLocationsData = async () => {
    const { data } = await getLocations({
      patientId: patient.id,
    }).unwrap();

    const locationsData = data.map((x) => ({
      ...x.location,
      addressType: x.type,
    }));

    setSelectedVisitLocation(
      locationsData.find((x) => x.addressType === "PRIMARY") || null,
    );

    setLocations(locationsData);
  };

  const [suggestedLocations, setSuggestedLocations] = useState([]);

  const suggestLocationsData = async () => {
    const { data } = await suggestLocations({
      address: addressSearch,
    }).unwrap();

    setSuggestedLocations(data);
  };

  useEffect(() => {
    if (addressSearch) {
      suggestLocationsData();
    } else {
      setSuggestedLocations([]);
    }
  }, [addressSearch]);

  useEffect(() => {
    if (patient) {
      getLocationsData();
    }
  }, [patient]);

  const handleSubmit = async (e, overrideTimeslot = false) => {
    try {
      if (!visitType) {
        console.log("Please select Appointment Type");
        showAlert(["Please select Appointment Type"]);
        return;
      }
      if (visitType !== "Normal" && !visitDate) {
        console.log("Please select Appointment Date");
        showAlert(["Please select Appointment Type"]);
        return;
      }
      const appDate = moment(visitDate).format("YYYY-MM-DD");
      // visitType !== "Normal"
      //   ? moment().format("YYYY-MM-DD")
      //   : moment(visitDate).format("YYYY-MM-DD");
      
      // Get InteractionGuideID from URL query parameters
      const interactionGuideId = new URLSearchParams(routerLocation.search).get('InteractionGuideID');
      
      const payload = {
        activity: `Creating a new appointment for provider ${
          selectedProvider.name
        } and patient ${patient.name} on ${appDate} with appointment type ${
          appointmentType.name
        } by user ${user?.details?.name || ""}.`,
        type: ACTIVITY_TYPE.APPOINTMENT_CREATED,
        data: {
          providerId: selectedProvider.id,
          patientId: patient.id,
          visitDate: appDate,
          created_from,
          marketId: selectedProvider?.market_id || selectedProvider?.provider_market_id,
        },
      };
      try {
       const {data: appointment} = await createOneAppointment({
          visitDate: appDate,
          appointmentTypeId: appointmentType.id,
          patientId: patient.id,
          providerId: selectedProvider.id,
          lastVisitDate: null,
          visitType,
          duration: appointmentType?.duration,
          isCoveredFor: patient.patientType === "Cross Cover",
          overrideTimeslot,
          created_from,
          visitLocationId:
            selectedVisitLocation === null
              ? null
              : selectedVisitLocation.addressType === "PRIMARY"
                ? null
                : selectedVisitLocation.id,
          marketId: selectedProvider?.market_id || selectedProvider?.provider_market_id,
          interactionGuideId: interactionGuideId ?? null
        }).unwrap();
        await createLog({
          ...payload,
          activity: `${payload.activity} CareSMS Appt Id: ${appointment.id}, Target Id: ${appointment.targetId}, Timeslot: ${appointment.timeslot} ${appointment.timezone ?? ""}`,
          data: {
            ...payload.data,
            id: appointment.id,
            timezone: appointment.timezone,
            targetId: appointment.targetId,
            timeslot: appointment.timeslot
          },
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();
        setAddOpen(false);
        setRecallSchedule(true);
        setDefaultValues();
      } catch (error) {
        error?.data?.showError && setError(error?.data?.error);
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
        showAlert([
          typeof error?.data?.message === "string"
            ? error?.data?.message
            : typeof error?.data?.error === "string"
            ? error?.data?.error
            : "Something went wrong",
        ]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onClose = () => {
    setDefaultValues();
    setAddOpen(false);
  };

  const patientData =
    patientType === "Recently discharged"
      ? filterOptions.dischargedPatients
      : filterOptions.patients;

  const cityList = filterOptions.city;

  const zipList = filterOptions.zip;

  const patientsListFilter = patientData
    .filter((i) => {
      if (location !== null) {
        return i.location.id === location.id;
      }

      if (searchType === "COMMUNITY") {
        return i.location.type !== "COMMUNITY_HOME";
      }

      if (["All", "Recently discharged"].includes(patientType)) {
        return true;
      }

      if (i.patientType === patientType) {
        return true;
      }

      return false;
    })
    .map((i) => {
      return {
        label:
          i.patientType === "New"
            ? `${i.name || ""}} |
              ${
                i?.location?.community !== null
                  ? i?.location?.community?.name
                  : i?.location?.name || ""
              } |
              ${i?.location?.address} |
              Added on: ${moment(i.addedOn).format("MMMM DD, YYYY")}
              `
            : i.patientType === "Overdue"
            ? `${i?.name || ""} |
                ${
                  i?.location?.community !== null
                    ? i?.location?.community?.name
                    : i?.location?.name || ""
                } |
                ${i?.location?.address} |
                Overdue by: ${i.slack} days |
                Last seen on: ${i.lastVisitDate} |
                ${i?.visitType ? `Last Appointment Type: ${i.visitType}` : ""}
              `
            : `${i?.name || ""} |
                ${
                  i?.location?.community !== null
                    ? i?.location?.community?.name
                    : i?.location?.name || ""
                } |
                ${i?.location?.address} |
                ${
                  i?.currentScheduled
                    ? `Currently Scheduled: ${i.currentScheduled} |`
                    : null
                }
              ${i?.visitType ? `Last Appointment Type: ${i.visitType}` : ""}
            `,
        value: i.patient_id,
        ...i,
      };
    });

  const patientsList =
    patientType === "Cross Cover" ? patients : patientsListFilter;

  const zoneList = filterOptions.zones;

  const CustomOption = ({ label, isFocused, isSelected }) => (
    <div
      key={label}
      className={`custom-option ${isFocused ? "focused" : ""} ${
        isSelected ? "selected" : ""}`}
    >
      {label.split("|").map((value, i) => {
        return (
          <span
            className={`${i === 0 ? "bold-600" : "font-14"} flex text-start`}
          >
            {value.split(":").length < 2 ? (
              value
            ) : (
              <Grid className="flex flex-row gap-1 text-start">
                {value.split(":").map((data, i) => (
                  <span
                    key={i}
                    className={`${i === 0 ? "bold-medium" : ""}`}
                    style={{
                      fontSize: 14,
                      color: "rgba(0,0,0,0.6)",
                    }}
                  >
                    {data}
                    {i === 0 && ":"}
                  </span>
                ))}
              </Grid>
            )}
          </span>
        );
      })}
    </div>
  );

  return (
    <div
      className={classNames(
        "absolute right-0 w-96 bg-white border-t border-b border-l opacity-100 transition-all top-[0px] min-h-fit border-secondarygrayborder",
        addOpen ? "right-0" : "right-[-400px]",
      )}
    >
      {loading && <Loading loading={loading} />}
      <div className="flex flex-row justify-between items-center p-4 w-full">
        <p className="m-0 text-2xl font-bold text-primaryblack">
          Add Appointment
        </p>
        <Tooltip title="Close">
          <button
            onClick={onClose}
            className="flex justify-center items-center w-10 rounded-full aspect-square bg-primarylightgrey"
          >
            <CloseSvg color={"#3062D4"} />
          </button>
        </Tooltip>
      </div>
      <div className="w-full border border-primarygrayborder" />
      <div className="h-[calc(100vh-180px)] overflow-y-auto">
        <div className="flex flex-col gap-8 w-full">
          <div className="flex relative flex-col gap-3 px-4 pt-4">
            <div className="flex flex-row justify-between items-center">
              <p className="m-0 text-xl font-semibold">Visit Date</p>
            </div>
            <input
              type="date"
              value={visitDate}
              placeholder="dd/mm/yyyy"
              // min={moment().format("YYYY-MM-DD")}
              // max={weeks && weeks[weeks.length - 1].date}
              onChange={(e) => {
                setVisitDate(e.target.value);
                // fetchFilterOptions(e.target.value);
              }}
              className="px-2 py-1 w-full rounded-md border border-primarygrayborder"
            />
          </div>
          <div className="w-full border border-primarygrayborder" />
          <div>
            <div className="flex flex-row justify-between items-center">
              <p className="px-4 m-0 text-xl font-semibold">Appointment Type</p>
            </div>
            <div className="flex flex-row gap-2 px-4 pt-4 w-full">
              <button
                onClick={() => {
                  setVisitType("NORMAL");
                }}
                className={classNames(
                  "flex flex-row items-center justify-center flex-1 px-3 py-2 rounded-md shadow-sm",
                  visitType === "NORMAL"
                    ? "border-2 border-primaryblue"
                    : "border border-primarygrayborder",
                )}
              >
                <p
                  className={classNames(
                    "m-0 text-sm",
                    visitType === "NORMAL" && "font-bold text-primaryblue",
                  )}
                >
                  Normal
                </p>
              </button>
              <button
                onClick={() => {
                  setVisitType("ADHOC");
                }}
                className={classNames(
                  "flex flex-row items-center justify-center flex-1 px-3 py-2 rounded-md shadow-sm",
                  visitType === "ADHOC"
                    ? "border-2 border-primaryblue"
                    : "border border-primarygrayborder",
                )}
              >
                <p
                  className={classNames(
                    "m-0 text-sm",
                    visitType === "ADHOC" && "font-bold text-primaryblue",
                  )}
                >
                  Ad-Hoc
                </p>
              </button>
            </div>
          </div>
          <div>
            <div className="flex flex-row justify-between items-center">
              <p className="px-4 m-0 text-xl font-semibold">Search By</p>
            </div>
            <div className="flex flex-col gap-4 py-4 w-full">
              <div className="flex flex-row gap-2 px-4 w-full">
                <button
                  onClick={() => {
                    setSearchType("ALL");
                    setLocation(null);
                  }}
                  className={classNames(
                    "flex flex-row items-center justify-center flex-1 px-3 py-2 rounded-md shadow-sm",
                    searchType === "ALL"
                      ? "border-2 border-primaryblue"
                      : "border border-primarygrayborder",
                  )}
                >
                  <p
                    className={classNames(
                      "m-0 text-sm",
                      searchType === "ALL" && "font-bold text-primaryblue",
                    )}
                  >
                    All
                  </p>
                </button>
                <button
                  onClick={() => {
                    setSearchType("COMMUNITY");
                  }}
                  className={classNames(
                    "flex flex-row items-center justify-center flex-1 px-3 py-2 rounded-md shadow-sm",
                    searchType === "COMMUNITY"
                      ? "border-2 border-primaryblue"
                      : "border border-primarygrayborder",
                  )}
                >
                  <p
                    className={classNames(
                      "m-0 text-sm",
                      searchType === "COMMUNITY" &&
                        "font-bold text-primaryblue",
                    )}
                  >
                    Community
                  </p>
                </button>
              </div>
              <div className="flex flex-row gap-2 px-4 w-full">
                <button
                  onClick={() => {
                    setSearchType("CITY");
                  }}
                  className={classNames(
                    "flex flex-row items-center justify-center flex-1 px-3 py-2 rounded-md shadow-sm",
                    searchType === "CITY"
                      ? "border-2 border-primaryblue"
                      : "border border-primarygrayborder",
                  )}
                >
                  <p
                    className={classNames(
                      "m-0 text-sm",
                      searchType === "CITY" && "font-bold text-primaryblue",
                    )}
                  >
                    City
                  </p>
                </button>
                <button
                  onClick={() => {
                    setSearchType("ZIP");
                    setLocation(null);
                  }}
                  className={classNames(
                    "flex flex-row items-center justify-center flex-1 px-3 py-2 rounded-md shadow-sm",
                    searchType === "ZIP"
                      ? "border-2 border-primaryblue"
                      : "border border-primarygrayborder",
                  )}
                >
                  <p
                    className={classNames(
                      "m-0 text-sm",
                      searchType === "ZIP" && "font-bold text-primaryblue",
                    )}
                  >
                    Zip
                  </p>
                </button>
                <button
                  onClick={() => {
                    setSearchType("ZONE");
                    setLocation(null);
                  }}
                  className={classNames(
                    "flex flex-row items-center justify-center flex-1 px-3 py-2 rounded-md shadow-sm",
                    searchType === "ZONE"
                      ? "border-2 border-primaryblue"
                      : "border border-primarygrayborder",
                  )}
                >
                  <p
                    className={classNames(
                      "m-0 text-sm",
                      searchType === "ZONE" && "font-bold text-primaryblue",
                    )}
                  >
                    Zone
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full border border-primarygrayborder" />
        <div className="flex flex-col gap-8 p-4 w-full">
          {searchType === "COMMUNITY" && (
            <div className="flex flex-col gap-3">
              <div className="flex flex-row justify-between items-center">
                <p className="m-0 text-xl font-semibold">Community</p>
              </div>
              <div className="flex relative flex-row items-center px-2 py-1 w-full rounded-md border border-primarygrayborder">
                <img src={Search_Icon} alt="Search Icon" className="w-5 h-5" />
                <input
                  type="text"
                  className="px-2 w-full outline-none"
                  placeholder="Search..."
                  value={
                    location !== null
                      ? location !== null
                        ? location?.name
                        : location?.name || ""
                      : communitySearch
                  }
                  onChange={(e) => {
                    setCommunitySearch(e.target.value);

                    if (e.target.value === "") {
                      setLocation(null);
                      setLocationsOpen(false);
                    } else {
                      setLocationsOpen(true);
                    }
                  }}
                />
                <button
                  onClick={() => {
                    setLocationsOpen(!locationOpen);
                  }}
                  className="rotate-[135deg] px-1 w-fit"
                >
                  <ArrowUpRight color={"#000"} />
                </button>
                <div
                  className={classNames(
                    "absolute left-0 top-9 z-50 w-full bg-white rounded-md border border-primarygrayborder",
                    locationOpen
                      ? "overflow-x-auto max-h-44 opacity-100"
                      : "hidden overflow-hidden h-0 opacity-30",
                  )}
                >
                  {filterOptions?.communities
                    ?.filter((x) => {
                      return x.name
                        ?.toLowerCase()
                        ?.includes(communitySearch?.toLowerCase());
                    })
                    ?.map((x, ind) => (
                      <button
                        key={ind}
                        onClick={() => {
                          setLocation(x);
                          setLocationsOpen(false);
                        }}
                        className="flex flex-col items-start w-full transition-all hover:bg-slate-300"
                      >
                        <p className="p-2 m-0 text-base font-semibold text-left cursor-pointer text-primaryblack">
                          {x.name}
                        </p>
                        {ind !== filterOptions?.communities?.length - 1 && (
                          <div className="w-full border border-primarygrayborder" />
                        )}
                      </button>
                    ))}
                </div>
              </div>
            </div>
          )}
          {searchType === "CITY" && (
            <div className="flex relative flex-col gap-3">
              <div className="flex flex-row justify-between items-center">
                <p className="m-0 text-xl font-semibold">City</p>
              </div>
              <div className="flex flex-row items-center px-2 py-1 w-full rounded-md border border-primarygrayborder">
                <img src={Search_Icon} alt="Search Icon" className="w-5 h-5" />
                <input
                  type="text"
                  className="px-2 w-full outline-none"
                  placeholder="Search..."
                  value={city !== null ? city : citySearch}
                  onChange={(e) => {
                    setCitySearch(e.target.value);

                    if (e.target.value === "") {
                      setCity(null);
                    }
                  }}
                />
                <button
                  onClick={() => {
                    setCityOpen(!cityOpen);
                  }}
                  className="rotate-[135deg] px-1 w-fit"
                >
                  <ArrowUpRight color={"#000"} />
                </button>
              </div>
              <div
                className={classNames(
                  "absolute z-50 left-0 w-full bg-white border rounded-md top-20 border-primarygrayborder",
                  cityOpen || citySearch !== ""
                    ? "max-h-44 overflow-x-auto opacity-100"
                    : "hidden h-0 overflow-hidden opacity-30",
                )}
              >
                {cityList
                  .filter((x) => {
                    return x.toLowerCase().includes(citySearch.toLowerCase());
                  })
                  .map((x, ind) => (
                    <button
                      key={ind}
                      onClick={() => {
                        setCity(x);
                        setCityOpen(false);
                        setCitySearch("");
                      }}
                      className="flex flex-col items-start w-full transition-all hover:bg-slate-300"
                    >
                      <p className="p-2 pb-0 m-0 text-base font-semibold text-left cursor-pointer text-primaryblack">
                        {x}
                      </p>
                      {ind !== filterOptions.city.length - 1 && (
                        <div className="w-full border border-primarygrayborder" />
                      )}
                    </button>
                  ))}
              </div>
            </div>
          )}
          {searchType === "ZIP" && (
            <div className="flex relative flex-col gap-3">
              <div className="flex flex-row justify-between items-center">
                <p className="m-0 text-xl font-semibold">Zip</p>
              </div>
              <div className="flex flex-row items-center px-2 py-1 w-full rounded-md border border-primarygrayborder">
                <img src={Search_Icon} alt="Search Icon" className="w-5 h-5" />
                <input
                  type="text"
                  className="px-2 w-full outline-none"
                  placeholder="Search..."
                  value={zip !== null ? zip : zipSearch}
                  onChange={(e) => {
                    setZipSearch(e.target.value);

                    if (e.target.value === "") {
                      setZip(null);
                    }
                  }}
                />
                <button
                  onClick={() => {
                    setZipOpen(!zipOpen);
                  }}
                  className="rotate-[135deg] px-1 w-fit"
                >
                  <ArrowUpRight color={"#000"} />
                </button>
              </div>
              <div
                className={classNames(
                  "absolute z-50 left-0 w-full bg-white border rounded-md top-20 border-primarygrayborder",
                  zipOpen || zipSearch !== ""
                    ? "max-h-44 overflow-x-auto opacity-100"
                    : "hidden h-0 overflow-hidden opacity-30",
                )}
              >
                {zipList
                  .filter((x) => {
                    return x.toLowerCase().includes(zipSearch.toLowerCase());
                  })
                  .map((x, ind) => (
                    <button
                      key={ind}
                      onClick={() => {
                        setZip(x);
                        setZipOpen(false);
                        setZipSearch("");
                      }}
                      className="flex flex-col items-start w-full transition-all hover:bg-slate-300"
                    >
                      <p className="p-2 pb-0 m-0 text-base font-semibold text-left cursor-pointer text-primaryblack">
                        {x}
                      </p>
                      {ind !== filterOptions.zip.length - 1 && (
                        <div className="w-full border border-primarygrayborder" />
                      )}
                    </button>
                  ))}
              </div>
            </div>
          )}
          {searchType === "ZONE" && (
            <div className="flex relative flex-col gap-3">
              <div className="flex flex-row justify-between items-center">
                <p className="m-0 text-xl font-semibold">Zone</p>
              </div>
              <div className="flex flex-row items-center px-2 py-1 w-full rounded-md border border-primarygrayborder">
                <img src={Search_Icon} alt="Search Icon" className="w-5 h-5" />
                <input
                  type="text"
                  className="px-2 w-full outline-none"
                  placeholder="Search..."
                  value={zone !== null ? zone.name : zoneSearch}
                  onChange={(e) => {
                    setZoneSearch(e.target.value);

                    if (e.target.value === "") {
                      setZone(null);
                    }
                  }}
                />
                <button
                  onClick={() => {
                    setZoneOpen(!zoneOpen);
                  }}
                  className="rotate-[135deg] px-1 w-fit"
                >
                  <ArrowUpRight color={"#000"} />
                </button>
              </div>
              <div
                className={classNames(
                  "absolute z-50 left-0 w-full bg-white border rounded-md top-20 border-primarygrayborder",
                  zoneOpen || zoneSearch !== ""
                    ? "max-h-44 overflow-x-auto opacity-100"
                    : "hidden h-0 overflow-hidden opacity-30",
                )}
              >
                {zoneList
                  .filter((x) => {
                    return x.name
                      .toLowerCase()
                      .includes(zoneSearch.toLowerCase());
                  })
                  .map((x, ind) => (
                    <button
                      key={ind}
                      onClick={() => {
                        setZone(x);
                        setZoneOpen(false);
                        setZoneSearch("");
                      }}
                      className="flex flex-col items-start w-full transition-all hover:bg-slate-300"
                    >
                      <p className="p-2 pb-0 m-0 text-base font-semibold text-left cursor-pointer text-primaryblack">
                        {x.name}
                      </p>
                      {ind !== filterOptions.zones.length - 1 && (
                        <div className="w-full border border-primarygrayborder" />
                      )}
                    </button>
                  ))}
              </div>
            </div>
          )}
          <div className="flex relative flex-col gap-3">
            <div className="flex flex-row justify-between items-center">
              <p className="m-0 text-xl font-semibold">Patient</p>
              <div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={(event) => {
                    setPatientAnchor(event.currentTarget);
                  }}
                  className="flex-row gap-1 d-flex align-items-center justify-content-center"
                >
                  <span className="text-xs font-bold color-1">
                    {patientType}
                  </span>
                  <DownArrow className="color-1" />
                </div>
                <Menu
                  open={Boolean(patientAnchor)}
                  anchorEl={patientAnchor}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  onClose={() => {
                    setPatientAnchor(null);
                  }}
                >
                  {[
                    "All",
                    "Overdue",
                    "New",
                    "Recently discharged",
                    user?.permissions?.includes("cc_home.cross_cover")
                      ? "Cross Cover"
                      : undefined,
                  ]
                    .filter(Boolean)
                    .map((data, ind) => (
                      <MenuItem
                        key={ind}
                        style={{
                          width: "200px",
                          fontSize: 14,
                        }}
                        onClick={() => {
                          setPatientType(data);
                          setPatientAnchor(null);
                        }}
                      >
                        {data}
                      </MenuItem>
                    ))}
                </Menu>
              </div>
            </div>
            <div className="flex flex-row items-center px-2 py-1 w-full rounded-md border border-primarygrayborder">
              <img src={Search_Icon} alt="Search Icon" className="w-5 h-5" />
              <input
                type="text"
                className="px-2 w-full outline-none"
                placeholder="Search..."
                value={patient !== null ? patient.name : patientSearch}
                onChange={(e) => {
                  setPatientSearch(e.target.value);

                  if (e.target.value === "" || patient !== null) {
                    setPatient(null);
                  }
                }}
              />
              <button
                onClick={() => {
                  setPatientsOpen(!patientsOpen);
                }}
                className="rotate-[135deg] px-1 w-fit"
              >
                <ArrowUpRight color={"#000"} />
              </button>
            </div>
            <div
              className={classNames(
                "absolute z-50 left-0 w-full bg-white border rounded-md top-20 border-primarygrayborder",
                patientsOpen || patientSearch !== ""
                  ? "max-h-44 overflow-x-auto opacity-100"
                  : "hidden h-0 overflow-hidden opacity-30",
              )}
            >
              {patientsList
                .filter((x) => {
                  return x?.name
                    ?.toLowerCase()
                    ?.includes(patientSearch.toLowerCase());
                })
                .filter((x) => {
                  if (city !== null) {
                    return x?.location?.address
                      ?.toLowerCase()
                      ?.includes(city.toLowerCase());
                  }

                  return true;
                })
                .filter((x) => {
                  if (zip !== null) {
                    return x?.location?.address
                      ?.toLowerCase()
                      ?.includes(zip.toLowerCase());
                  }

                  return true;
                })
                .filter((x) => {
                  if (zone !== null) {
                    return x?.location?.zones
                      ?.map((z) => z.name)
                      ?.includes(zone.name);
                  }

                  return true;
                })
                .map((x, ind) => (
                  <button
                    key={ind}
                    onClick={() => {
                      setPatient(x);
                      setPatientsOpen(false);
                      setPatientSearch("");
                      setMessage([]);
                      setPatientSelected({
                        address: x.location.address,
                        coords: {
                          lat: x.location.latitude,
                          lng: x.location.longitude,
                        },
                        locationId: x.location.id,
                        name:
                          x.location?.community !== null
                            ? x.location?.community?.name
                            : x.location?.name || "",
                        patients: [
                          {
                            id: x.id,
                            name: x.name,
                            visitType: x.visitType,
                          },
                        ],
                      });
                    }}
                    // className="flex items-start w-full transition-all hover:bg-slate-300"
                    className="flex flex-col items-start w-full transition-all hover:bg-slate-300"
                  >
                    <div className="p-2">
                      <p className="m-0 text-base font-semibold text-left cursor-pointer text-primaryblack">
                        {x.name}
                      </p>
                      {x.dob && (
                        <span className="flex gap-2 items-center">
                          <Icon name="20-calendar" />
                          {moment(x.dob).format("MM/DD/YYYY")}
                        </span>
                      )}
                      <span className="flex gap-2 items-center text-left">
                        Last visit date:{" "}
                        {x.lastVisitDate
                          ? x.lastVisitDate
                          : "NA"}
                      </span>
                      <span className="flex gap-2 items-center text-left">
                        Last visit by:{" "}
                        {x.lastVisitProvider ? x.lastVisitProvider : "NA"}
                      </span>
                      <span className="flex gap-2 items-center text-left">
                        Next visit on:{" "}
                        {x.currentScheduled
                          ? x.currentScheduled
                          : "NA"}
                      </span>
                      <span className="flex gap-2 items-center text-left">
                        Next visit status:{" "}
                        {x.currentScheduledAppointmentStatus
                          ? x.currentScheduledAppointmentStatus
                          : "NA"}
                      </span>
                      <span className="flex gap-2 items-center text-left">
                        Next visit with:{" "}
                        {x.currentScheduledProvider
                          ? x.currentScheduledProvider
                          : "NA"}
                      </span>
                    </div>
                    {ind !== filterOptions.patients.length - 1 && (
                      <div className="w-full border border-primarygrayborder" />
                    )}
                    {/* <CustomOption label={x.label} /> */}
                  </button>
                ))}
            </div>
          </div>
          {patient !== null && selectedVisitLocation !== null && (
            <div className="flex relative flex-col gap-3 p-4 rounded-md border bg-slate-100 border-primarygrayborder">
              <div className="flex justify-between items-center">
                <p className="m-0 text-sm font-semibold text-gray-600 capitalize">
                  APPOINTMENT ADDRESS
                </p>
                <p className="m-0 text-xs font-semibold text-primaryblue">
                  {selectedVisitLocation.addressType}
                </p>
              </div>
              <p className="m-0 w-3/4 text-sm font-semibold text-left text-primaryblack">
                {selectedVisitLocation.street}, {selectedVisitLocation.city},{" "}
                {selectedVisitLocation.state} {selectedVisitLocation.zip}
              </p>
              <button
                onClick={() => setChangeAddressModalOpen(true)}
                className="flex bg-white justify-between items-center text-sm border-[2px] rounded-md p-2 text-primaryblue border-primaryblue max-w-fit"
              >
                Change Address
              </button>
              <LatLongDisplay
                latitude={selectedVisitLocation.latitude}
                longitude={selectedVisitLocation.longitude}
                address={selectedVisitLocation}
                patientId={patient?.id}
                onAddressUpdate={(updatedLocation) => {
                  // Update the location in state
                  const updatedLocations = locations.map((loc) =>
                    loc.id === updatedLocation.id ? updatedLocation : loc,
                  );
                  setLocations(updatedLocations);
                  setSelectedVisitLocation(updatedLocation);
                }}
                editable={true} // Based on user permissions
              />
            </div>
          )}
          {changeAddressModalOpen === true && (
            <div className="flex relative flex-col gap-3 p-4 bg-amber-50 border-[1px] border-amber-400 rounded-md">
              <div className="flex justify-between items-center">
                <p className="m-0 text-sm font-semibold text-amber-900 capitalize">
                  Select or enter address
                </p>
                <button
                  onClick={() => {
                    setChangeAddressModalOpen(false);
                    setSelectedAddress(null);
                    setAddress("");
                    setSaveAddressToProfile(false);
                    setUseManualEntry(false);
                    setManualAddress(null);
                  }}
                >
                  <p className="m-0 text-xs font-semibold text-gray-500 underline">
                    Cancel
                  </p>
                </button>
              </div>
              <div className="flex flex-col gap-2">
                {locations.map((x) => (
                  <button
                    key={x.id}
                    onClick={() => {
                      setSelectedVisitLocation(x);
                    }}
                    className={classNames(
                      "flex flex-col gap-2 items-start p-2 w-full rounded-md",
                      selectedVisitLocation?.id === x.id
                        ? "border-[1px] border-primaryblue bg-subtleblue"
                        : "border-[1px] border-primarygrayborder bg-white",
                    )}
                  >
                    <p className="m-0 text-xs font-semibold text-left text-gray-500">
                      {x.addressType}
                    </p>
                    <p className="m-0 text-xs font-semibold text-left text-primaryblack">
                      {x.street}, {x.city}, {x.state} {x.zip}
                    </p>
                  </button>
                ))}
              </div>
              <div className="flex flex-col gap-3">
                <p className="m-0 text-xs font-semibold text-left text-gray-500 capitalize">
                  Or enter a new address
                </p>

                {/* Manual Entry Checkbox */}
                <div className="flex gap-2 items-center">
                  <input
                    type="checkbox"
                    id="manualEntryCheckbox"
                    checked={useManualEntry}
                    onChange={(e) => {
                      setUseManualEntry(e.target.checked);
                      if (!e.target.checked) {
                        setManualAddress(null);
                      } else {
                        setAddress("");
                        setSelectedAddress(null);
                        setSuggestedLocations([]);
                      }
                    }}
                    className="w-4 h-4 cursor-pointer"
                  />
                  <label
                    htmlFor="manualEntryCheckbox"
                    className="m-0 text-xs text-gray-700 cursor-pointer"
                  >
                    Turn off auto-fill address
                  </label>
                </div>

                {/* Conditional rendering: either manual entry or search */}
                {useManualEntry ? (
                  <div className="flex flex-col gap-3">
                    <input
                      type="text"
                      placeholder="Street"
                      className="p-2 w-full text-sm rounded-md border border-primarygrayborder"
                      value={manualAddress?.street || ""}
                      onChange={(e) =>
                        setManualAddress({
                          ...manualAddress,
                          street: e.target.value,
                        })
                      }
                    />
                    <div className="flex gap-2">
                      <input
                        type="text"
                        placeholder="City"
                        className="p-2 w-full text-sm rounded-md border border-primarygrayborder"
                        value={manualAddress?.city || ""}
                        onChange={(e) =>
                          setManualAddress({
                            ...manualAddress,
                            city: e.target.value,
                          })
                        }
                      />
                      <input
                        type="text"
                        placeholder="State"
                        className="p-2 w-1/3 text-sm rounded-md border border-primarygrayborder"
                        value={manualAddress?.state || ""}
                        onChange={(e) =>
                          setManualAddress({
                            ...manualAddress,
                            state: e.target.value,
                          })
                        }
                      />
                    </div>
                    <input
                      type="text"
                      placeholder="Zip Code"
                      className="p-2 w-full text-sm rounded-md border border-primarygrayborder"
                      value={manualAddress?.zip || ""}
                      onChange={(e) =>
                        setManualAddress({
                          ...manualAddress,
                          zip: e.target.value,
                        })
                      }
                    />
                  </div>
                ) : (
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Enter address"
                      className="p-2 w-full text-sm rounded-md border border-primarygrayborder"
                      value={
                        address !== ""
                          ? address
                          : selectedAddress !== null
                          ? `${selectedAddress?.street}, ${selectedAddress?.city}, ${selectedAddress?.state} ${selectedAddress?.zip}`
                          : ""
                      }
                      onChange={(e) => {
                        setAddress(e.target.value);
                        // Clear selected address when user starts typing or deletes text
                        if (selectedAddress !== null) {
                          setSelectedAddress(null);
                        }
                      }}
                    />
                    {suggestedLocations.length > 0 && (
                      <div className="flex overflow-y-auto absolute left-0 top-full z-10 flex-col gap-2 mt-1 w-full max-h-28 bg-white rounded-md border shadow-lg">
                        {suggestedLocations.map((x) => (
                          <button
                            key={x.id}
                            onClick={() => {
                              setSelectedAddress(x);
                              setAddress("");
                              setSuggestedLocations([]);
                            }}
                            className="flex flex-col gap-4 items-start p-2 w-full border-b border-primarygrayborder"
                          >
                            <p className="m-0 text-xs font-semibold text-left text-primaryblack">
                              {x.street}, {x.city}, {x.state} {x.zip}
                            </p>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                {/* {(selectedAddress !== null || (useManualEntry && manualAddress)) && (
                  <div className="flex gap-2 items-center">
                    <input
                      type="checkbox"
                      id="saveAddressCheckbox"
                      checked={saveAddressToProfile}
                      onChange={(e) =>
                        setSaveAddressToProfile(e.target.checked)
                      }
                      className="w-4 h-4 cursor-pointer"
                    />
                    <label
                      htmlFor="saveAddressCheckbox"
                      className="m-0 text-xs text-gray-700 cursor-pointer"
                    >
                      Save this to patient's profile for future use
                    </label>
                  </div>
                )} */}
                {(selectedAddress !== null ||
                  (useManualEntry && manualAddress)) && (
                  <button
                    onClick={attachLocationData}
                    disabled={
                      useManualEntry &&
                      (!manualAddress?.street ||
                        !manualAddress?.city ||
                        !manualAddress?.state ||
                        !manualAddress?.zip)
                    }
                    className={classNames(
                      "flex w-full justify-between items-center text-sm border-[2px] rounded-md px-2 py-1 text-white text-center",
                      useManualEntry &&
                        (!manualAddress?.street ||
                          !manualAddress?.city ||
                          !manualAddress?.state ||
                          !manualAddress?.zip)
                        ? "bg-gray-400 border-gray-400 cursor-not-allowed"
                        : "bg-amber-500 border-amber-500",
                    )}
                  >
                    <p className="m-0 mx-auto font-semibold">Save Address</p>
                  </button>
                )}
              </div>
            </div>
          )}
          <div className="flex relative flex-col gap-3">
            <div className="flex flex-row justify-between items-center">
              <p className="m-0 text-xl font-semibold">Appointment Type</p>
            </div>
            <div className="flex flex-row items-center px-2 py-1 w-full rounded-md border border-primarygrayborder">
              <input
                type="text"
                className="px-2 w-full outline-none"
                placeholder="Search..."
                value={
                  // appointmentType !== null
                  //   ? appointmentType.name
                  //   :
                  appointmentTypeSearch
                }
                disabled={patient === null}
                onChange={(e) => {
                  setAppointmentTypeSearch(e.target.value);

                  if (appointmentType != null) {
                    setAppointmentType(null);
                  }
                }}
              />
              <button
                onClick={() => {
                  if (patient === null) {
                    setMessage(["Please select a patient first"]);
                    return;
                  }
                  setAppointmentTypesOpen(!appointmentTypesOpen);
                }}
                className="rotate-[135deg] px-1 w-fit"
              >
                <ArrowUpRight color={"#000"} />
              </button>
            </div>
            <div
              className={classNames(
                "absolute z-50 left-0 w-full bg-white border rounded-md top-20 border-primarygrayborder",
                appointmentTypesOpen ||
                  (appointmentTypeSearch !== appointmentType?.name &&
                    appointmentTypeSearch !== "")
                  ? "max-h-44 overflow-x-auto opacity-100"
                  : "hidden h-0 overflow-hidden opacity-30",
              )}
            >
              {appointmentTypes
                .filter((x) => {
                  return x.name
                    .toLowerCase()
                    .includes(appointmentTypeSearch.toLowerCase());
                })
                .map((x, ind) => (
                  <button
                    key={ind}
                    onClick={() => {
                      setAppointmentType(x);
                      setAppointmentTypesOpen(false);
                      setAppointmentTypeSearch(x.name);
                    }}
                    className="flex flex-col items-start w-full transition-all hover:bg-slate-300"
                  >
                    <p>
                      <p className="p-2 m-0 text-base font-semibold text-left cursor-pointer text-primaryblack">
                        {x.name}
                      </p>
                      <span className="flex gap-2 items-center px-2">
                        <Icon name="20-time-clock" />
                        {x.duration} mins
                      </span>
                    </p>
                    {ind !== appointmentTypes.length - 1 && (
                      <div className="w-full border border-primarygrayborder" />
                    )}
                  </button>
                ))}
            </div>
          </div>
        </div>
        <div className="w-full border border-primarygrayborder" />
        {patient?.name && (
          <p className="p-4 m-0 text-sm">
            You are choosing to add this appointment for{" "}
            <span className="font-semibold">{patient?.name}</span> to{" "}
            <span className="font-semibold">{selectedProvider?.name}'s</span>{" "}
            schedule for{" "}
            <span className="font-semibold">
              {moment(visitDate).format("MMMM DD, YYYY")}
            </span>
            . This appointment will be placed last in the Provider's schedule
            for the day.
          </p>
        )}
        {message.length > 0 && (
          <ul className="p-0 px-4 m-0 font-semibold text-red-500">
            {message?.map((msg) => {
              return <li>{msg}</li>;
            })}
          </ul>
        )}
        <div className="p-4 mb-4 w-full">
          <button
            disabled={
              visitDate === "" || patient === null || appointmentType === null
            }
            onClick={handleSubmit}
            className="flex flex-row justify-center items-center px-3 py-2 w-full rounded-md border shadow-sm bg-primaryblue border-primaryblue disabled:opacity-40"
          >
            <p className="m-0 text-base font-semibold text-white">Confirm</p>
          </button>
        </div>
        {error != null && (
          <InfoModal
            open={error != null}
            subtext={error}
            title="Timeslot unavailable"
            type={"error"}
            handleClose={() => {
              setError(null);
            }}
            primaryClick={(e) => {
              handleSubmit(e, true);
              setError(null);
            }}
            secondaryClick={() => {
              setError(null);
            }}
            secondaryTitle={"No"}
            primaryTitle={"Yes"}
          />
        )}
      </div>
    </div>
  );
};

export default AppointmentAddModal;
